// MODULES
import { useTranslation } from 'next-i18next';
import React, { useCallback, useMemo } from 'react';
import { useCollectible } from 'src/features/common/collectible/hooks/collectible.hooks';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
// RESOURCES
import { Button } from 'src/ui/common/atoms/button';
import { useGetActiveTokenTransaction } from '../../hooks/useGetActiveTokenTransaction.hook';
import { ContactSellerModal } from '../../modals/contact-seller-modal';
import { useActionWithAuthorization } from './actions.hooks';

interface ILocale {
    contactSeller: string;
}

export const NftContactSellerAction = () => {
    const { t } = useTranslation(['actions']);
    const nft = useCollectible();
    const activeTransactions = useGetActiveTokenTransaction();
    const { isNinjaTemplate, isOceanTemplate, isSyndicate } = useGetUniverseTemplate();

    const locale: ILocale = useMemo(
        () => ({
            contactSeller: t('trade.contactSeller', { ns: 'actions' }),
        }),
        [t]
    );

    const showContactSellerModal = useCallback(() => {
        ContactSellerModal.open({ nft: nft! });
    }, [nft]);

    const actionWithAuthorization = useActionWithAuthorization({
        callback: showContactSellerModal,
    });

    const getButtonVariant = useCallback(() => {
        if (isNinjaTemplate) {
            return 'whiteRounded';
        }
        if (isOceanTemplate) {
            return 'o_white';
        }
        if (isSyndicate) {
            return 'outline';
        }
        return 'white';
    }, [isNinjaTemplate, isOceanTemplate]);

    return (
        <>
            <Button
                size="lg"
                variant={getButtonVariant()}
                onClick={actionWithAuthorization}
                disabled={!!activeTransactions[0]}
                data-test-id="contact-seller-btn"
            >
                {locale.contactSeller}
            </Button>
        </>
    );
};